import { InputSelect, Paragraph, Show, tokens } from '@welbe/web-design-system';
import { Fragment, useContext } from 'react';
import { statusInfo } from '../../DrawerEmployees.constants';
import { DrawerEmployeesContext } from '../../DrawerEmployees.context';
import {
	getAmountAllResults,
	getAmountReceivedResults,
	renderDate,
} from '../../DrawerEmployees.functions';
import { FlexRow, ItemWrapper } from '../../DrawerEmployees.styles';
import { DrawerEmployeesContextProps } from '../../DrawerEmployees.types';
import { Alert } from '../Alert/Alert';
import { StyledHeartIcon } from './Exams.styles';

export const Exams = (): JSX.Element => {
	const { selectedFormData, handleChangeData, options, isMultiple } =
		useContext<DrawerEmployeesContextProps>(DrawerEmployeesContext);

	if (isMultiple) {
		return (
			<ItemWrapper>
				<Alert text="Solo es posible editar el estatus de los estudios de forma individual." />
			</ItemWrapper>
		);
	}

	return (
		<ItemWrapper>
			{selectedFormData?.map((item) => {
				const receivedResults = getAmountReceivedResults(item?.orders);
				const allResults = getAmountAllResults(item?.orders);
				const isDisabled =
					item?.canEdit === false || item?.canComplete === false;
				const isFinished = receivedResults === allResults;
				const initialHeartIconColor =
					receivedResults === 0
						? tokens.color_gray_medium
						: tokens.color_primary;
				const heartIconColor = isFinished
					? tokens.color_welbe
					: initialHeartIconColor;

				return (
					<Fragment key={item.actionId}>
						<ItemWrapper gap="5px">
							<Paragraph fontWeight="700">{item.name}</Paragraph>
							<Paragraph>
								{renderDate(item?.dateStart, item?.dateEnd)}
							</Paragraph>
							<InputSelect
								options={options}
								disabled={isDisabled}
								onChange={(value) =>
									handleChangeData(item.actionId, 'exams', value.id)
								}
								value={options.find((option) => option.id === item.status)}
								statusDot
								statusInfo={statusInfo}
							/>
						</ItemWrapper>
						<Show when={receivedResults > 0} fallback={null}>
							<ItemWrapper gap="5px">
								<Paragraph fontWeight="700">Resultados recibidos</Paragraph>
								<FlexRow>
									<StyledHeartIcon color={heartIconColor} />
									<Paragraph fontWeight="500" color={tokens.color_primary}>
										{receivedResults} de {allResults}
									</Paragraph>
								</FlexRow>
							</ItemWrapper>
						</Show>
					</Fragment>
				);
			})}
			<Alert
				text="Solo es posible cambiar el estatus de los estudios a ‘Completado’ cuando
        se recibieron todos los resultados del laboratorio."
			/>
		</ItemWrapper>
	);
};
